<template>
  <Showcase
    :request-is-auth="false"
    :url-set-rows="TRADE_OFFER_URL_SHOWCASE"
    :url-action-query="`${EXPAND_SHOWCASE_LOT}&search[Active]=active`"
    :title="title"
  />
</template>
<script setup>
import { defineProps } from 'vue'
import { TRADE_OFFER_URL_SHOWCASE, EXPAND_SHOWCASE_LOT } from '@/utils/consts'
import Showcase from '@/components/views/Showcase/VShowcase'
defineProps({
  title: {
    type: String,
    required: true
  }
})
</script>
